// One-click demo sign-in buttons. The account list is injected at BUILD time via
// the git-ignored env var VITE_DEMO_LOGINS (JSON: { role: { email, password } }).
// When it is unset — i.e. any non-demo build — parseDemoLogins returns [] and the
// buttons never render, so production login is unaffected.
export type DemoLogin = { role: string; label: string; email: string; password: string };

const LABEL: Record<string, string> = {
  org_admin: 'Admin',
  manager: 'Manager',
  finance: 'Finance',
  technician: 'Technician',
  owner_scoped: 'Owner',
};

export function parseDemoLogins(raw: string | undefined, roles: string[]): DemoLogin[] {
  if (!raw) return [];
  let obj: Record<string, { email?: string; password?: string }>;
  try { obj = JSON.parse(raw); } catch { return []; }
  return roles
    .filter((r) => obj[r]?.email && obj[r]?.password)
    .map((r) => ({ role: r, label: LABEL[r] ?? r, email: obj[r]!.email!, password: obj[r]!.password! }));
}
